import { SettingsState } from "./settingsAtom";

type ColorArguments = readonly [string, string | null] | "skip";
type GetColorsOutput =
  | {
      readonly primaryArguments: ColorArguments;
      readonly secondaryArguments: ColorArguments;
    }
  | "initializing";

export function colorsSideEffects(
  settingsResult: SettingsState
): GetColorsOutput {
  if (settingsResult === "initializing") {
    return "initializing";
  } else {
    const colors = settingsResult.styleOptions?.colors;
    return {
      primaryArguments:
        colors?.primary === undefined
          ? "skip"
          : ["--primary-color", colors?.primary ?? null],
      secondaryArguments:
        colors?.secondary === undefined
          ? "skip"
          : ["--secondary-color", colors?.secondary ?? null],
    };
  }
}
